// @flow
import React from 'react';
import {DropdownItem, UncontrolledDropdown} from 'reactstrap'
import AbstractField from "./AbstractField";
import {COMPONENT_CHILDREN} from './../Utils2';
import {mergeAddons} from "./../utils"
import getValue from "redux-form/lib/events/getValue"
import NumberField from "./NumberField"
import getMapFromList from "./../utils/getMapFromList"

/**
 * Field pro editaci jednotky s jejím typem.
 */
class JednotkaTypField extends AbstractField {

    static PropTypes = {
        int: React.PropTypes.bool,
        double: React.PropTypes.bool,
        value: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]), // string musí být, protože při prázdném poli dává redux prázdný string, místo objektu!
        typy: React.PropTypes.array.isRequired,
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    static defaultProps = {
        int: false,
        double: false,
    };

    state = {};

    componentDidMount() {
        this.selectFirstIfNeeded(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.selectFirstIfNeeded(nextProps);
    }

    getJednotkaValue = (value) => {
        if (value == null) {
            return "";
        }

        if (typeof value === "object") {
            return value.jednotka;
        } else {
            return "";
        }
    };

    getTypValue = (value) => {
        if (value == null) {
            return "";
        }

        if (typeof value === "object") {
            return typeof value.typ !== "undefined" ? value.typ : "";
        } else {
            return "";
        }
    };

    selectFirstIfNeeded = (props) => {
        const {typy, onChange, value} = props;
        const typ = this.getTypValue(value);
        const jednotka = this.getJednotkaValue(value);
        if (!typ) {
            onChange({
                typ: typy[0].kod,
                jednotka
            })
        }
    }

    handleBlur = (e) => {
        const {value, onBlur} = this.props;
        onBlur(value);
    }

    handleChangeTyp = (typ) => {
        const {onChange, value} = this.props;
        let newValue;
        if (value) {
            newValue = {
                ...value,
                typ
            }
        } else {
            newValue = {
                typ
            }
        }

        onChange(newValue);
    };

    handleTypChange = (eventOrValue) => {
        const jednotkaValue = getValue(eventOrValue, false);
        const {onChange, value} = this.props;

        let newValue;
        if (value) {
            newValue = {
                ...value,
                jednotka: jednotkaValue
            }
        } else {
            newValue = {
                jednotka: jednotkaValue
            }
        }

        onChange(newValue);
    };

    render() {
        const {disabled, int, double, typy, addonsBefore, addonsAfter, onChange, onBlur, typDoklad, value, ...props} = this.props;

        const typ = this.getTypValue(value);
        const jednotka = this.getJednotkaValue(value);
        const typObj = getMapFromList(typy, "kod")[typ];   // TODO [stanekpa] optimalizovat pres store

        const customAddons = <div className="input-group-btn">
            <UncontrolledDropdown disabled={disabled} id="typy" title={typObj ? typObj.nazev : ""} onBlur={this.handleBlur}>
                {typy.map((c, index) => <DropdownItem
                    onClick={() => this.handleChangeTyp(c.kod)}
                    active={typ === c.kod}
                    eventKey={index}
                    key={index}>
                    {c.nazev}
                </DropdownItem>)}
            </UncontrolledDropdown>
        </div>;

        const field = <NumberField
            int={int}
            double={double}
            onChange={this.handleTypChange}
            onBlur={this.handleBlur}
            value={jednotka}
            disabled={disabled}
            {...props}
        />;

        return this.renderFieldWithAddons(field, addonsBefore, mergeAddons(addonsAfter, customAddons));
    }
}
export default JednotkaTypField;
